import React from "react"
import "./header.css"
import logo from "../../assets/logo.png"

const Header = () => {
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header")
    header.classList.toggle("active", window.scrollY > 100)
  })
  return (
    <>
      <header className='header'>
        <div className='container d_flex'>
          <div>
            <img src={logo} alt='Logo' className="logo"/>
          </div>
          <div className='navlink'>
            <ul className="link f_flex">
              <li>
                <a href='#home'>Home</a>
              </li>
              <li>
                <a href='#skills'>Skills</a>
              </li>
              <li>
                <a href='#portfolio'>Portfolio</a>
              </li>
              <li>
                <a href='#contact'>Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </header>
    </>
  )
}

export default Header
